import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { findIndex } from 'lodash';
import '../../styles/core.scss';
import css from './class-group-selector.scss';

import DropdownSelect from '../dropdown-select/dropdown-select';

const ClassGroupSelector = ({ selectedClassId, selectedGroupId, classList, groupList,
    onClassChange, onGroupChange }) => {
    const classData = classList || [];
    const groupData = groupList || [{ name: 'default group' }];

    const selectedClass = findItem(classData, 'classId', selectedClassId);
    const selectedGroup = findItem(groupData, 'groupId', selectedGroupId);

    return (
        (selectedClass && selectedClass.displaySelect !== undefined) ?
            (<div className={`${css['class-group-selector']} box brand-medium dark-6`}>
                <div className={css['selects-holder']} >
                    <div className={`${css['selector-classroom']}`}>
                        <DropdownSelect
                            rawData={classData}
                            labelProperty="name"
                            selectedIndex={selectedClass.indexValue}
                            onChange={onClassChange} />
                    </div>
                    <div className={`${css['selector-group']}`}>
                        <DropdownSelect
                            rawData={groupData}
                            labelProperty="name"
                            selectedIndex={selectedGroup.indexValue}
                            onChange={onGroupChange} />
                    </div>
                </div>
            </div>) : (<div />)
    );
};

function findItem(itemList, itemName, itemValue) {
    const num = itemList.length;
    let selectedItem;
    if (num > 1) {
        let myIndex = findIndex(itemList, (item) => {
            let bool = false;
            if (item[itemName] === itemValue) {
                bool = true;
            }
            return bool;
        }) || 0;
        myIndex = (myIndex < 0) ? 0 : myIndex;
        const myItem = itemList[myIndex];
        selectedItem = { ...myItem, displaySelect: true, indexValue: myIndex };
    } else if (num === 1) {
        selectedItem = { ...itemList[0], displaySelect: false, indexValue: 0 };
    } else {
        selectedItem = {};
    }

    return selectedItem;
}

ClassGroupSelector.propTypes = {
    selectedClassId: PropTypes.number,
    selectedGroupId: PropTypes.number,
    classList: PropTypes.array,
    groupList: PropTypes.array,
    onClassChange: PropTypes.func,
    onGroupChange: PropTypes.func
};

export default styleable(css)(ClassGroupSelector);



// WEBPACK FOOTER //
// ./components/class-group-selector/class-group-selector.js